module.exports = __webpack_public_path__ + "static/media/LVS_06.3fd585fc.jpeg";